import React, { useState } from 'react';
import {
  Grid,
  TextField,
  Typography,
  Button,
  IconButton,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import { Cancel } from '@material-ui/icons';
import Context from '../../../../context';
import { Editor } from '../../../../components';
import {
  postContentTK,
  deleteContentTK,
  updateContentTK,
} from '../../../../services';

const initContent = {
  id: '',
  titleId: '',
  titleEn: '',
  contentId: '',
  contentEn: '',
  oldImages: [],
  images: [],
  imagesRead: [],
  no: '',
};

const CrudTK = ({ onCancel, action, title, data }: any) => {
  const { enqueueSnackbar } = useSnackbar();
  const context = React.useContext(Context);
  const [contentState, setContentState] = useState<any>({
    ...initContent,
    ...data,
  });
  const [loadingButtonState, setLoadingButtonState] = useState(false);

  const handleImageChange = (event: any, index: number) => {
    let tempImages = contentState.images;
    let tempImagesRead = contentState.imagesRead;
    tempImages[index] = event.target.files[0];
    tempImagesRead[index] = URL.createObjectURL(event.target.files[0]);
    if (event.target.files && event.target.files[0]) {
      setContentState({
        ...contentState,
        images: tempImages,
        imagesRead: tempImagesRead,
      });
    }
  };

  const handleImageCancel = (index: number) => {
    let tempImages = contentState.images;
    let tempImagesRead = contentState.imagesRead;
    tempImages[index] = null;
    tempImagesRead[index] = null;
    setContentState({
      ...contentState,
      images: tempImages,
      imagesRead: tempImagesRead,
    });
  };

  const handleContentChange = (e: any) => {
    setContentState({
      ...contentState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      const body = new FormData();
      body.append('id_type', data.id_type);
      body.append('title_id', contentState.titleId);
      body.append('title_en', contentState.titleEn);
      body.append('content_id', contentState.contentId);
      body.append('content_en', contentState.contentEn);
      body.append('no', contentState.no);
      if (contentState.images.length) {
        contentState.images.forEach((image: any) => {
          body.append('image', image);
        });
      }
      if (action === 'Edit') {
        body.append('old_images', JSON.stringify(contentState.oldImages));
        body.append(
          'read_images',
          JSON.stringify(
            contentState.imagesRead
              .filter(
                (r: string) => r && r.includes(`${process.env.REACT_APP_URL}`)
              )
              .map((r: string) => r.split('/').pop())
          )
        );
      }
      setLoadingButtonState(true);
      const res =
        action === 'Edit'
          ? await updateContentTK(contentState.id, body)
          : await postContentTK(body);
      setLoadingButtonState(false);
      if (res.status === 'error') {
        enqueueSnackbar(res.message, {
          variant: 'error',
        });
        return;
      }
      enqueueSnackbar(`Berhasil merubah data ${contentState.titleId}`, {
        variant: 'success',
      });
      onCancel();
      setContentState(initContent);
    } catch (err: any) {
      setLoadingButtonState(false);
      enqueueSnackbar(err.message, {
        variant: 'error',
      });
    }
  };

  return (
    <>
      <Typography color='primary' variant='h4' style={{ marginBottom: '2rem' }}>
        {action} Data {title}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div style={{ display: 'flex', gap: 16 }}>
            {[0, 1].map((num) => (
              <div
                key={num}
                style={{
                  width: 200,
                  height: 150,
                  backgroundColor: '#f0f0f0',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 4,
                }}
              >
                {!contentState.imagesRead[num] && (
                  <>
                    <Button
                      variant='outlined'
                      color='primary'
                      component='label'
                    >
                      Upload Image
                      <input
                        type='file'
                        onChange={(e) => handleImageChange(e, num)}
                        hidden
                      />
                    </Button>
                    <Typography color='textSecondary' style={{ fontSize: 12 }}>
                      * Max size 5mb
                    </Typography>
                  </>
                )}

                {contentState.imagesRead[num] && (
                  <div style={{ position: 'relative' }}>
                    <img
                      src={contentState.imagesRead[num]}
                      alt='testing'
                      style={{
                        width: 200,
                        height: 150,
                        objectFit: 'contain',
                      }}
                    />
                    <IconButton
                      color='primary'
                      aria-label='upload picture'
                      component='span'
                      onClick={() => handleImageCancel(num)}
                      style={{ position: 'absolute', top: -12, right: -12 }}
                    >
                      <Cancel />
                    </IconButton>
                  </div>
                )}
              </div>
            ))}
          </div>
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            type='number'
            name='no'
            label='No.'
            variant='outlined'
            value={contentState.no}
            onChange={handleContentChange}
            style={{ maxWidth: 200 }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            name='titleId'
            label='Title ID'
            variant='outlined'
            value={contentState.titleId}
            onChange={handleContentChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            name='titleEn'
            label='Title EN'
            variant='outlined'
            value={contentState.titleEn}
            onChange={handleContentChange}
          />
        </Grid>
        <Grid item xs={6}>
          <Typography color='primary' variant='h6' gutterBottom>
            Bahasa Indonesia
          </Typography>
          <Editor
            content={contentState.contentId}
            onChange={(content: any) =>
              setContentState({ ...contentState, contentId: content })
            }
          />
        </Grid>
        <Grid item xs={6}>
          <Typography color='primary' variant='h6' gutterBottom>
            English
          </Typography>
          <Editor
            content={contentState.contentEn}
            onChange={(content: any) =>
              setContentState({ ...contentState, contentEn: content })
            }
          />
        </Grid>
      </Grid>
      <div
        style={{
          marginTop: 32,
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        {action === 'Edit' && (
          <Button
            variant='contained'
            onClick={() => {
              context.openDialog(
                'Hapus Data',
                `Apakah anda yakin ingin menghapus data ${data.titleId} ?`,
                async () => {
                  try {
                    const res = await deleteContentTK(data.id, {
                      images: data.oldImages,
                    });
                    if (res.status === 'error') {
                      enqueueSnackbar(res.message, {
                        variant: 'error',
                      });
                      return;
                    }
                    context.closeDialog();
                    enqueueSnackbar(`Berhasil menghapus data ${data.titleId}`, {
                      variant: 'success',
                    });
                    onCancel();
                    setContentState(initContent);
                  } catch (err: any) {
                    enqueueSnackbar(err.message, {
                      variant: 'error',
                    });
                  }
                }
              );
            }}
            disabled={loadingButtonState}
          >
            Delete {title}
          </Button>
        )}
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 16,
            flex: 1,
          }}
        >
          <Button
            variant='outlined'
            onClick={() => {
              onCancel();
              setContentState(initContent);
            }}
            disabled={loadingButtonState}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            color='primary'
            disabled={loadingButtonState}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};

export default CrudTK;
